import type { ButtonProps } from "antd";

import { FilterFilled, FilterOutlined } from "@ant-design/icons";
import { Badge, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { LIST_PARAMS_PREVIEW_COLOR } from "@/modules/list";

import { useListParamsPreviewButton } from "./list-params-preview-button.hook";

const { Text } = Typography;
const i18Key = "global:listParamsPreview";

export const ListParamsPreviewButton = ({
  onClick,
  ...buttonProps
}: ButtonProps) => {
  const { t } = useTranslation();
  const { count, hasParams, togglePreview } = useListParamsPreviewButton();

  const onButtonClick: ButtonProps["onClick"] = (e) => {
    togglePreview();
    onClick?.(e);
  };

  return (
    <Button {...buttonProps} onClick={onButtonClick}>
      {hasParams ? <FilterFilled /> : <FilterOutlined />}
      <Text>{t(`${i18Key}.title${hasParams ? "With" : "Without"}`)}</Text>
      {hasParams && <Badge count={count} color={LIST_PARAMS_PREVIEW_COLOR} />}
    </Button>
  );
};
